module.exports = __webpack_public_path__ + "img/704c8c06bc1dc8b00c901e3cf14dd01b-enable_2fa_3.png";